import createContext from 'create-react-context';
var RowContext = createContext({});
export default RowContext;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.12.2@antd/es/grid/RowContext.js
// module id = 283
// module chunks = 0